"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ERROR_CODES = void 0;
exports.API_ERROR_CODES = Object.freeze({
    MICROSOFT_GRAPH_API_ERROR: 1,
    GENERAL_ERROR: 2,
    VALIDATION_ERROR: 3,
    INGESTION_ERROR: 4,
    EXCEL_DRIVE_ITEM_NOT_FOUND_ERROR: 5,
    EXCEL_RANGE_NOT_FOUND_ERROR: 6,
    EXCEL_WORKSHEET_FOR_CHART_NOT_FOUND_ERROR: 7,
    EXCEL_CHART_NOT_FOUND_ERROR: 8,
    TABLE_NOT_GENERATED_ERROR: 9,
    SVG_NOT_GENERATED_ERROR: 10,
    POWERPOINT_GROUP_NOT_FOUND_ERROR: 11,
    POWERPOINT_DRIVE_ITEM_NOT_FOUND_ERROR: 12,
    LIBRARY_ITEM_CORRUPTED: 13,
    EXCEL_NAMED_RANGE_NOT_FOUND_ERROR: 'E1001-101',
    EXCEL_DRIVE_ITEM_NOT_FOUND_ERROR_NEW: 'E1001-102',
    LIBRARY_ITEM_CORRUPTED_NEW: 'E1001-103',
    EXCEL_WORKSHEET_FOR_CHART_NOT_FOUND_ERROR_NEW: 'E1001-104',
    EXCEL_CHART_NOT_FOUND_ERROR_NEW: 'E1001-105',
    TABLE_NOT_GENERATED_ERROR_NEW: 'E1001-106',
    SVG_NOT_GENERATED_ERROR_NEW: 'E1001-107',
    POWERPOINT_GROUP_NOT_FOUND_ERROR_NEW: 'E1001-108',
    POWERPOINT_DRIVE_ITEM_NOT_FOUND_ERROR_NEW: 'E1001-109',
    GRAPH_SERVICE_ERROR: 'E1001-110',
    ALREADY_UPDATED_ERROR: 'E1001-111',
    CONTENT_ID_LISTS_DIFFER_ERROR: 'E1001-112',
    EXCEL_WORKSHEET_NOT_FOUND_ERROR: 'E1001-113',
    DRIVE_NOT_FOUND_IN_SHAREPOINT_ERROR: 'E1001-114',
    FOLDER_NOT_FOUND_IN_SHAREPOINT_ERROR: 'E1001-115',
    WORKBOOK_NOT_FOUND_IN_SHAREPOINT_ERROR: 'E1001-116',
    MISSING_CONFIGURATION_VALUE_ERROR: 'E1001-117',
    NOT_ALLOWED_TO_RETRIEVE_DRAFT_LIBRARY_ITEMS_ERROR: 'E1001-118',
    CONTENT_NOT_FOUND_ERROR: 'E1001-119',
    INVALID_TAG_ERROR: 'E1001-121',
    INVALID_CONTENT_ERROR: 'E1001-122',
    INVALID_CONTENT_LINK_ERROR: 'E1001-123',
    PERMISSIONS_CHECK_FAILED_ERROR: 'E1001-124',
    INVALID_MODEL_STATE_ERROR: 'E1001-125',
    EXCEL_WORKSHEET_CELL_RANGE_NOT_FOUND_ERROR: 'E1001-126',
    INVALID_PANEL_TYPE_SUPPLIED_ERROR: 'E1001-127',
    LIBRARY_ITEM_ID_POWERPOINT_DOES_NOT_EXIST_ERROR: 'E1001-128',
    LIBRARY_ITEM_ID_POWERBI_REPORT_DOES_NOT_EXIST_ERROR: 'E1001-129',
    LIBRARY_ITEM_ID_EXCEL_CELL_RANGE_ERROR: 'E1001-130',
    LIBRARY_ITEM_ID_EXCEL_NAMED_RANGE_ERROR: 'E1001-131',
    LIBRARY_ITEM_ID_EXCEL_CHART_ERROR: 'E1001-132',
    INVALID_KEY_FOCUS_AREA_ID_ERROR: 'E1001-133',
    INVALID_TAG_TEXT_EMPTY_ERROR: 'E1001-134',
    INVALID_TAG_TEXT_TOO_LONG_ERROR: 'E1001-135',
    INVALID_TAG_ILLEGAL_CHARACTERS_ERROR: 'E1001-136',
    INVALID_CONTENT_HYPOTHESIS_ALREADY_EXISTS_ERROR: 'E1001-137',
    INVALID_CONTENT_KPI_ALREADY_EXISTS_ERROR: 'E1001-138',
    INVALID_CONTENT_ANALYSIS_ALREADY_EXISTS_ERROR: 'E1001-139',
    INVALID_CONTENT_INSIGHT_ALREADY_EXISTS_ERROR: 'E1001-140',
    INVALID_CONTENT_TAG_ALREADY_EXISTS_ERROR: 'E1001-141',
    INVALID_CONTENT_DIAGNOSTIC_ALREADY_EXISTS_ERROR: 'E1001-142',
    INVALID_TOPIC_NO_PANEL_SUPPLIED_ERROR: 'E1001-143',
    NOT_ALLOWED_TO_SHARE_ERROR: 'E1001-144',
    NOT_ALLOWED_TO_UPDATE_WORKFLOW_STATUS_ERROR: 'E1001-145',
    INVALID_CONTENT_DATA_ERROR: 'E1002-101',
});
